import React from "react";
import { FiGrid } from "react-icons/fi";
import MiniGamePage from "./MiniGamePage";
import { game2048Api } from "../../utils/miniGameApi";

const Game2048 = () => (
  <MiniGamePage
    title="2048"
    selfLabel="2048"
    description="Manage 2048 settings and view user play history."
    icon={FiGrid}
    api={game2048Api}
    scoreLabel="Highest Tile"
    switchTo={[
      { to: "/fruit-cut", label: "Fruit Cut" },
      { to: "/tap-game", label: "Tap Game" },
      { to: "/boom-cards-game", label: "Boom Cards" },
    ]}
  />
);

export default Game2048;
